import Link from "next/link";
import { usePathname } from "next/navigation";
import { CSSProperties } from "react";

interface NavLinkProps {
  onClick?: Function;
  name: string;
  style?: CSSProperties;
  nameToUse?: string;
  showBottomBorder?: boolean;
  queryParams?: string;
}

export const NavLink = ({
  onClick,
  name,
  style = {},
  nameToUse,
  showBottomBorder,
  queryParams,
  ...props
}: NavLinkProps) => {
  const pathName = decodeURIComponent(usePathname() || "");
  return (
    <Link
      onClick={() => {
        onClick && onClick(nameToUse ?? name);
      }}
      href={`/${nameToUse ?? name}${queryParams ?? ""}`}
      style={style}
      {...props}
      className={[
        "capitalize",
        "leading-6",
        "text-gray-900",
        "px-4",
        "hover:bg-gray-50",
        "text-center",
        "pb-3",
        "text-[16px]",
        "flex",
        "items-center",
        // styles?.header?.navigationText,
        `link ${
          pathName === `/${decodeURIComponent(name)}` || showBottomBorder
            ? "border-b-4"
            : ""
        }`,
      ].join(" ")}
    >
      {decodeURIComponent(name)}
    </Link>
  );
};
